export default [
  {
    name: "Dashboard",
    icon: "fa fa-tachometer",
    path: "/dashboard"
  },
  {
    name: "Drivers",
    icon: "fa fa-users",
    path: "/drivers"
  },
  {
    name: "Transactions",
    icon: "fa fa-credit-card",
    path: "/transactions/sales"
  },
  {
    name: "Terminals",
    icon: "fa fa-calculator",
    path: "/terminals"
  },
  {
    name: "Support",
    icon: "fa fa-support",
    path: "/support",
    isRoute: false
  },
  {
    name: "System Status",
    icon: "fa fa-bolt",
    path: "/status",
    isRoute: false
  },
  {
    name: "Developer Tools",
    icon: "fa fa-code",
    path: "/developer"
  }
];
